class RpcError {
    constructor(jqXHR, textStatus, errorThrown) {
        this.jqXHR = jqXHR
        this.textStatus = textStatus
        this.errorThrown = errorThrown
        this.handled = false
        this.newError = null
    }

    getJQXHR() {
        return this.jqXHR
    }

    getTextStatus() {
        return this.textStatus
    }

    getErrorThrown() {
        return this.errorThrown
    }

    getException() {
        return this.errorThrown.exception;
    }

    handle(newError = null) {
        this.handled = true;
        this.newError = newError;
    }

    handleOnException(exception, newError = null) {
        if (this.getException() === exception) {
            this.handle(newError)
        }
    }

    handleOnExceptions(exceptions, errorMapper = () => null) {
        const exception = exceptions.find(e => e === this.getException())
        if (exception) this.handle(errorMapper(this.errorThrown))
    }

    isHandled() {
        return this.handled
    }

    getNewError() {
        return this.newError
    }
}

export default RpcError


// WEBPACK FOOTER //
// ./web/js/util/rpc/RpcError.js